import { fetchAllUserGroups, fetchFindAllCity, fetchFindTicketCreateQueryOptions, fetchGetPermissions, fetchGetValidToolList, getCountryCellList } from "@/api/service/common";
import { getProvider } from "@/api/service/order";
import { CANONICAL_COUNTRY_CODE, LANG } from "@/utils";
import { delLSContaining, getLocalStorage, setLocalStorage } from '@/utils/localStorage';
import { Action, createAction } from 'redux-actions';
export interface initStateDataProps {
    cityList: Array<any>,
    businessTypeList: Array<any>,
    channelList: Array<any>,
    requesterTypeList: Array<any>,
    permissions: Array<any>,
    groupList: Array<any>,
    countryList: Array<any>,
    openCountryList: Array<any>,
}

export const initStateData: initStateDataProps = {
    cityList: [],
    businessTypeList: [],
    channelList: [],
    requesterTypeList: [],
    permissions: [],
    groupList: [],
    countryList: [],
    openCountryList: [],
}

export const resetState = createAction('RESET_ALLPROMOTION_STATE', () => (initStateData))
export const resetFetchState = createAction('RESET_ALLPROMOTION_FETCH_STATE')

// 获取工具
export const getValidToolListSuccess = createAction('SET_VALID_TOOL_LIST_SUCCESS')
export const getValidToolList = function (data: any) {
    return (dispatch: (arg0: Action<any>) => void) => {
        return fetchGetValidToolList(data)
            .then((res) => res.data)
            .then((json) => {
                dispatch(getValidToolListSuccess(json.data))
            })
            .catch((err) => {
                console.info(err);
            });
    };
};

// 获取用户权限
export const getPermissionsSuccess = createAction('GET_PERMISSIONS')
export const getPermissions = function (params = {}) {
    return (dispatch: (arg0: Action<any>) => void) => {
        const localStoragePermissions = getLocalStorage(`permissions${CANONICAL_COUNTRY_CODE}`)
        localStoragePermissions && dispatch(getPermissionsSuccess(localStoragePermissions))
        return fetchGetPermissions(params)
            .then((res) => res.data)
            .then((json) => {
                dispatch(getPermissionsSuccess(json.data))
                delLSContaining('permissions')
                setLocalStorage(`permissions${CANONICAL_COUNTRY_CODE}`, json.data.data)

            })
            .catch((err) => {
                console.info(err);
            });
    };
};

// 获取订单查询信息
export const GetProviderSuccess = createAction('GET_PROVIDER_OPTIONS')
export const fetchProvider = function (params = {}) {
    return (dispatch: (arg0: Action<any>) => void) => {
        return getProvider(params)
            .then((res) => res.data)
            .then((json) => {
                dispatch(GetProviderSuccess(json.data))
            })
            .catch((err) => {
                console.info(err);
            });
    };
};

// 更新工单 用户类型 业务线 渠道
export const GetTicketOptionsSuccess = createAction('GET_TICKET_OPTIONS')
export const getTicketOptions = function (params = {}) {
    return (dispatch: (arg0: Action<any>) => void) => {
        return fetchFindTicketCreateQueryOptions(params)
            .then((res) => res.data)
            .then((json) => {
                dispatch(GetTicketOptionsSuccess(json.data))
            })
            .catch((err) => {
                console.info(err);
            });
    };
};

// 更新 城市列表
export const GetAllCitySuccess = createAction('GET_ALL_CITY')
export const getAllCity = function (params = {}) {
    return (dispatch: (arg0: Action<any>) => void) => {
        const localStorageCityList = getLocalStorage(`cityList${CANONICAL_COUNTRY_CODE}${LANG}`)
        localStorageCityList && dispatch(GetAllCitySuccess(localStorageCityList))
        return fetchFindAllCity(params)
            .then((res) => res.data)
            .then((json) => {
                dispatch(GetAllCitySuccess(json.data))
                delLSContaining('cityList')
                setLocalStorage(`cityList${CANONICAL_COUNTRY_CODE}${LANG}`, json.data)
            })
            .catch((err) => {
                console.info(err);
            });
    };
};

// 更新 获取所有分组 
export const getAllUserGroupsSuccess = createAction('GET_ALL_GROUPS')
export const getAllUserGroups = function (data: { transformable: number; }) {
    return (dispatch: (arg0: Action<any>) => void) => {
        const localStorageGroupList = getLocalStorage(`groupList${CANONICAL_COUNTRY_CODE}`)
        localStorageGroupList && dispatch(getAllUserGroupsSuccess(localStorageGroupList))
        return fetchAllUserGroups(data)
            .then((res) => res.data)
            .then((json) => {
                dispatch(getAllUserGroupsSuccess(json.data))
                delLSContaining('groupList')
                setLocalStorage(`groupList${CANONICAL_COUNTRY_CODE}`, json.data)
            })
            .catch((err) => {
                console.info(err);
            });
    };
};

// 更新 电话前缀 列表
export const GetPhonePrefixSuccess = createAction('GET_ALL_PHONE')
export const GetPhonePrefixList = function () {
    return (dispatch: (arg0: Action<any>) => void) => {
        const localStorageCountryList = getLocalStorage(`country_list_${LANG}_All`)
        localStorageCountryList && dispatch(GetPhonePrefixSuccess(localStorageCountryList))
        const params = {
            lang: LANG.replace("-", "_")
        }
        return getCountryCellList(params)
            .then((res) => res.data)
            .then((json) => {
                dispatch(GetPhonePrefixSuccess(json.data))
                delLSContaining('country_list_')
                setLocalStorage(`country_list_${LANG}_All`, json.data)
            })
            .catch((err) => {
                console.info(err);
            });
    };
};

